import React, { useState } from 'react';
import { X } from 'lucide-react';
import eingang from '../images/Eingangsbereich.jpeg';
import wartezimmer from '../images/Wartebereich.jpeg';
import behandlung1 from '../images/Behandlungszimmer_1.jpeg';
import behandlung2 from '../images/Behandlungszimmer_2_Ultra.jpeg';
import Eingang from '../images/Eingang.jpeg';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: Eingang, title: "Eingang" },
    { id: 2, src: eingang, title: "Empfangsbereich" },
    { id: 3, src: wartezimmer, title: "Wartezimmer" },
    { id: 4, src: behandlung1, title: "Behandlungszimmer 1" },
    { id: 5, src: behandlung2, title: "Behandlungszimmer 2 Ultraschall" }
  ];

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">Unsere Praxis in Bildern</h2>
        </div>

        <div className="gallery-grid-simple">
          {images.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item-simple" 
              onClick={() => setSelectedImage(image)}
              style={{ cursor: 'pointer' }}
            >
              <img 
                src={image.src} 
                alt={image.title}
                className="gallery-image-simple"
              />
              <div className="gallery-item-title">
                {image.title}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
          <div className="gallery-modal-content-simple" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={() => setSelectedImage(null)}>
              <X size={32} />
            </button>
            <img 
              src={selectedImage.src} 
              className="gallery-modal-image" 
              alt={selectedImage.title} 
            />
          </div>
        </div>
      )}
    </section>
  );
}